<div class="dashboard">
  <nav class="dashboard__nav">
    <div class="dashboard__nav__logobox">
      <span class="dashboard__nav__logobox__title">GenerEdge</span>
      <span class="dashboard__nav__logobox__subtitle">Dashboard</span>
    </div>
    <ul class="dashboard__nav__list">
      <li class="dashboard__nav__list__item disabled">
        <a routerLink="/overview">Overview</a>
      </li>
      <li class="dashboard__nav__list__item">
        <a routerLink="/tasks">Tasks</a>
      </li>
      <li class="dashboard__nav__list__item">
        <a routerLink="/contacts">Contacts</a>
      </li>
      <li class="dashboard__nav__list__item disabled">
        <a routerLink="/">Tracking</a>
      </li>
      <li class="dashboard__nav__list__item disabled">
        <a routerLink="/">Campaigns</a>
      </li>
      <li class="dashboard__nav__list__item disabled">
        <a routerLink="/">Notes</a>
      </li>
      <li class="dashboard__nav__list__item disabled">
        <a routerLink="/">Settings</a>
      </li>
      <hr />
      <li class="dashboard__nav__list__item">
        <a href="https://greenenergyfundapp.com/admin/" target="_blank"
          >Admin Dashboard</a
        >
      </li>
    </ul>
  </nav>
  <main class="dashboard__main">
    <div class="dashboard__main__top-bar">
      <div class="container">
        <span>Dashboard</span>
        <button class="button" (click)="onLogout()">Logout</button>
      </div>
    </div>
    <div class="dashboard__main__outlet">
      <router-outlet />
    </div>
  </main>
</div>
